import React from 'react'
import { Popover } from 'antd'

import type { LntPopoverProps } from './types'

export const LntPopover: React.FC<LntPopoverProps> = props => {
  const { children, ...restProps } = props

  return <Popover { ...restProps }>{ children }</Popover>
}
